import { render, staticRenderFns } from "./editEmployeeSkills.vue?vue&type=template&id=6e04fcd2&scoped=true"
import script from "./editEmployeeSkills.vue?vue&type=script&lang=js"
export * from "./editEmployeeSkills.vue?vue&type=script&lang=js"
import style0 from "./editEmployeeSkills.vue?vue&type=style&index=0&id=6e04fcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04fcd2",
  null
  
)

export default component.exports